import React, { useState } from 'react';
import { View, Text, TextInput, StyleSheet, ScrollView } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';

const ReservationForm = () => {
  const [reservationFormData, setReservationFormData] = useState({
    email: 'dev105@innspire.com',
    phone: '+46707462461',
    specialRequest: '',
  });

  const { t } = useTranslation();
  const getStyles = useCssStyle();

  const handleInputChange = (field, value) => {
    setReservationFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  return (
    <ScrollView contentContainerStyle={getStyles(['reservationFormContainer'])} showsVerticalScrollIndicator={false}>
      {/* Email Input */}
      <View style={getStyles(['reservationFormInputRow'])}>
        <Text style={getStyles(['reservationFormLabel'])}>
          {t('tableRes.email')}<Text style={getStyles(['required'])}> *</Text>
        </Text>
        <TextInput
          style={getStyles(['reservationFormInput'])}
          value={reservationFormData.email}
          onChangeText={(value) => handleInputChange('email', value)}
          placeholder="Email"
          keyboardType="email-address"
          pointerEvents='none'
        />
      </View>

      {/* Phone Input */}
      <View style={getStyles(['reservationFormInputRow'])}>
        <Text style={getStyles(['reservationFormLabel'])}>
          {t('tableRes.phone')}<Text style={getStyles(['required'])}> *</Text>
        </Text>
        <TextInput
          style={getStyles(['reservationFormInput'])}
          value={reservationFormData.phone}
          onChangeText={(value) => handleInputChange('phone', value)}
          placeholder="Phone"
          keyboardType="phone-pad"
          pointerEvents='none'
        />
      </View>

      {/* Special Request Input */}
      <Text style={getStyles(['reservationFormLabel'])}>{t('tableRes.special_request')}</Text>
      <TextInput
        style={getStyles(['reservationFormTextArea'])}
        value={reservationFormData.specialRequest}
        onChangeText={(value) => handleInputChange('specialRequest', value)}
        placeholder="Please include any special requests here..."
        multiline={true}
        numberOfLines={4}
      />
    </ScrollView>
  );
};

export default ReservationForm;
